module.exports = __webpack_public_path__ + "img/istore.1c6bf61c.svg";